<template>
	<!--------------------FINESTRA ESPORTAZIONE LOG------------------------------------------------>
	<div v-if="logsType" class="dialog draggable-item-little bg-light light w-100-sm w-100-md w-75-lg w-50-xl h-50">
		<div class="dialog-title pl-10">
			{{ $t('Export') }} : {{ logsType_label }}
			<span class="button square closer" @click="$root.$emit('CLOSEEXPORTLOGSDIALOG')"></span>
		</div>
		<div class="dialog-content overflow bg-light">
			<div class="form-group">
				<label>{{ $t("Which logs do you want to export?") }}</label>
				<select class="select" v-model="logsType">
					<option key="ALL_CLIENT" :value="{ key: 'ALL_CLIENT', id: '', name: '' }"> {{ $t("Web Client Logs") }}</option>
					<template v-if="$session.getRoomPC() != null">
						<option key="ALL_AGENT" :value="{ key: 'ALL_AGENT', id: '', name: '' }"> {{ $t("Agent Logs") }}</option>
						<option key="ALL_BACKUPS" :value="{ key: 'ALL_BACKUPS', id: '', name: '' }"> {{ $t("Backup logs only") }}</option>
						<option key="ALL_RESTORES" :value="{ key: 'ALL_RESTORES', id: '', name: '' }"> {{ $t("Restore logs only") }}</option>
						<optgroup v-if="backups && Object.keys(backups) != 0" :label="$t('Backup Jobs')">
							<option v-for="backup in backups" :key="backup.id" :value="{ key: 'BACKUP', id: backup.id, name: backup.name }"> {{ backup.name }}</option>
						</optgroup>
						<optgroup v-if="restores && Object.keys(restores) != 0" :label="$t('Restores')">
							<option v-for="restore in restores" :key="restore.id" :value="{ key: 'RESTORE', id: restore.id, name: restore.restorename }"> {{ restore.restorename }}</option>
						</optgroup>
					</template>
				</select>
			</div>
			<div v-if="logsType && logsType.key != 'ALL_CLIENT'" class="remark info">
				{{ $t("Agent logs are exported to the selected folder on the remote machine.") }}
			</div>
			<!--SCELTA DEL PERCORSO-->
			<SelectedResourcesLayout v-if="logsType && logsType.key != 'ALL_CLIENT'" buttonText="Select destination folder" :singleItem="true"
				:isDisabled="false" :list="selectedNodes" :heightPercentage="0" :canCancel="true" :type="$ONEServiceType.FileFolder"
				@clickFunction="toggleFileSystemSidebar"
			/>
		</div>
		<div class="dialog-actions">
			<ClientMessageView ref="FMV" :commands="['exportAgentLogs']"/>

			<div v-if="wait" class="form-group text-center"> <span class="mif-spinner2 fg-primary ani-spin"></span> </div>
			<button v-else class="button secondary"  @click="exportAgentLogs()" :disabled="logsType.key != 'ALL_CLIENT' && selectedNodes.length == 0">
				<span>{{ $t("Export") }}</span>
			</button>
			<button class="button js-dialog-close" @click="$root.$emit('CLOSEEXPORTLOGSDIALOG')">{{ $t("Close") }}</button>

		</div>
	</div>
</template>
<script>
import { draggableMixin } from '../../mixins/draggable-mixin';
import { ClientTreeNode, FileSystemSidebarConfig } from '../../models/TreeNode';
import { ClientMessage } from '../../utils/objects';
import { assignProperties, cookieManager, isValid } from '../../utils/utilitiesmodule';
import SelectedResourcesLayout from "../utils/SelectedResourcesLayout.vue";
import ClientMessageView from './view/ClientMessageView.vue';
import { getSARootPath } from '../../utils/entityMethods/serviceAccount';

export default {

	mixins: [draggableMixin],
	components: {
		SelectedResourcesLayout,
		ClientMessageView
	},
	name: "ExportLogsDialog",
	props: {
		inputLogsType: Object
	},
	data() {
		return {
			logsType: null,
			selectedNodes: [
			],

			logsType_label: "",
			backups: null,
			restores: null,
			wait: false,
		}
	},

	watch: {
		logsType: {
			handler(value) {
				switch (value.key) {
					case "ALL_CLIENT":
						this.logsType_label="IperiusONE Client Logs";
						break;

					case "ALL_AGENT":
						this.logsType_label="IperiusONE Agent Logs";
						break;

					case "ALL_BACKUPS":
						this.logsType_label=this.$t("All backups logs");
						break;

					case "ALL_RESTORES":
						this.logsType_label=this.$t("All restores logs");
						break;

					case "BACKUP":
						this.logsType_label=this.$t("Backup {0} logs", this.logsType.name);
						break;

					case "RESTORE":
						this.logsType_label=this.$t("Restore {0} logs", this.logsType.restorename);
						break;
				}
			}
		}
	},
	mounted() {
		var downloadFolderPath=cookieManager.getCookie("downloadFolderPath");
		if (isValid(downloadFolderPath)) {
			this.selectedNodes.push(new ClientTreeNode("", "", downloadFolderPath, this.$FileFolderEntityType.FN_Folder));
		}
		let self=this;
		self.logsType=self.inputLogsType;
		self.$root.$once("SETPAGEPROP", (prop, backups_received) => {

			if (prop=="socket_backups") {

				if (self.backups==null) {
					self.backups=backups_received;
				} else {
					assignProperties(backups_received, self.backups, false);
				}
			}
		});

		this.$root.$once("addRestoreToPage", async restores => {
			if (self.restores==null) {
				self.restores=restores;
			} else {
				for (let [id, job] of Object.entries(restores)) {
					self.restores[id]=job;
				}
			}
		});

	},
	methods: {
		getSARootPath,

		async toggleFileSystemSidebar() {

			var config=FileSystemSidebarConfig.getForDestination(
				this.$ONEServiceType.FileFolder,
				null,//client
				this.getSARootPath(null),
				false // root non selezionabile
			);

			this.$root.$emit("toggleFileSystemSidebar", this.selectedNodes, config);
		},

		exportAgentLogs() {
			this.$root.$emit("closeFileSystemSidebar");
			this.$refs.FMV.setClientMessage(null);
			this.wait=true;

			if (this.logsType.key=="ALL_CLIENT") {
				this.$root.exportLogs();
				this.$refs.FMV.setClientMessage(ClientMessage.success("Logs exported with successfully", null, "exportAgentLogs"));
				this.wait=false;
				return;
			}

			this.$root.socket("EXPORTAGENTLOGS", this.logsType, this.selectedNodes[0].path).then(_ => {
				/*if (ok) {
					this.$root.$emit('CLOSEEXPORTLOGSDIALOG');
				}*/
				this.wait=false;
			});

		},
	}
}
</script>
